import { Trash2 } from "lucide-react";
import React from "react";

interface DeleteButtonProps {
    onDelete: () => void;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ onDelete }) => {
    return (
        <button
            onClick={onDelete}
            className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 dark:bg-red-900/20 dark:text-red-400 dark:hover:bg-red-900/50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 transition"
            title="Delete / Archive Listing"
        >
            <Trash2 className="w-5 h-5 mr-2" />
            Delete
        </button>
    );
};

export default DeleteButton;
